module.exports = __webpack_public_path__ + "img/file-long.e0195f43.svg";